import { render, staticRenderFns } from "./ProfitReportTable.vue?vue&type=template&id=52051b94&scoped=true"
import script from "./ProfitReportTable.vue?vue&type=script&lang=js"
export * from "./ProfitReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52051b94",
  null
  
)

export default component.exports